import { render, staticRenderFns } from "./officialEvent_node_form.vue?vue&type=template&id=5a521c64&"
import script from "./officialEvent_node_form.vue?vue&type=script&lang=js&"
export * from "./officialEvent_node_form.vue?vue&type=script&lang=js&"
import style0 from "./officialEvent_node_form.vue?vue&type=style&index=0&id=5a521c64&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports